// extracted by mini-css-extract-plugin
export default {"alert":"complete-verification_alert__4ew6+","textSeparator":"complete-verification_textSeparator__b1cCE"};